<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-briefcase"></i> Advogado</h3>
      </div>
    </div>
    <AdvogadoAdd v-if="showAdd" ref="AdvogadoAdd" v-on:Back="onBack" />
    <AdvogadoList v-else ref="AdvogadoList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import AdvogadoAdd from './components/add/advogadoadd.vue'
import AdvogadoList from './components/list/advogadolist.vue'

export default {
  name: 'Advogado',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    AdvogadoAdd,
    AdvogadoList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.AdvogadoAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/advogado/advogado.vue